<template>
  <v-container fluid class="l-center l-base">
    <v-card class="l-card" :loading="loading">
      <div class="header-card">
        <v-card-text tag="p" class="name">{{dataId}}</v-card-text>
        <v-card-text tag="p" class="action">{{title}}</v-card-text>
      </div>
      <div class="body-wrapper">
        <v-card-text class="note" tag="p"
          >{{question}}</v-card-text
        >
        <v-card-text class="note-description" tag="p"
          >{{description}}</v-card-text
        >
      </div>
      <div class="alert-wrapper">
        <v-alert dense outlined type="error" v-if="error != '' && error != null">
          {{error}}
        </v-alert>
      </div>
      <div class="footer-wrapper">
        <v-btn elevation="2" rounded @click="$emit('close')">Cancel</v-btn>
        <v-btn elevation="2" :loading="loading" rounded class="c-btn-primary" data-123 @click="$emit('delete')"
          >Delete</v-btn
        >
      </div>
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
@import "@/components/styles/variable";
.header-card {
  text-align: center;
  width: 600px;
  background-color: rgba(#007bb6, $opacity-hight);
  color: #fff;
  padding: 35px 0;
  .name {
    font-size: 1rem;
    margin-bottom: 10px;
  }
  .action {
    font-size: 1.35rem;
  }
}
p {
  margin: 0;
  padding: 0;
}
.body-wrapper {
  text-align: center;
  padding: 32px 0;
  padding-bottom: 12px;
  $tColor: rgba(#000, $opacity-medium);
  .note {
    margin-bottom: 8px;
    font-size: 0.9rem;
    color: $tColor;
  }
  .note-description {
    font-size: 1.05rem;
    color: $tColor;
  }
}
.footer-wrapper {
  margin-top: 12px;
  display: flex;
  justify-content: center;
  gap: 0 16px;
  padding-bottom: 28px;
}
</style>


<script>
export default {
  props:{
    error:{
      default: ''
    },
    loading:{
      default: false
    },
    dataId: {},
    title: {},
    question:{},
    description:{}
  }
}
</script>